'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFolder = function IoIosFolder(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.4 13.8c0.3 0 0.6 0.3 0.6 0.6v18.6c0 1.1-0.8 2-1.8 2h-31.2c-1.1 0-2-0.9-2-2v-18.6c0-0.3 0.3-0.6 0.6-0.6h33.8z m-1.2-6.3c1 0 1.8 0.8 1.8 1.8v3.3c-0.2-0.1-0.4-0.1-0.6-0.1h-33.8c-0.2 0-0.4 0-0.6 0.1v-5.8c0-1 0.9-1.8 2-1.8h8.7c0.6 0 0.9 0.2 1.3 0.5l1.8 1.8c0.2 0.2 0.3 0.2 0.5 0.2h18.9z' })
        )
    );
};

exports.default = IoIosFolder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-folder.js
// module id = 2165
// module chunks = 0